import React from 'react';
import { Link, useMatch } from "../../../vendor/router-ROUTER_TARGET";

import IconCollection from './svg/IconCollection';

import { useSelector } from "react-redux";

// TODO - optimization re-render if only selected

function CollectionMenu() {
  const storeRoute = useSelector(state => state.storeRoute);
  const storePopup = useSelector(state => state.storePopup);
  const isConnected = useSelector(state => state.isConnected)
  let match = useMatch({ path: '/collection', end: true });
  const setHistory = () => {
    if (isConnected) {
      storeRoute.goTo('/collection');
    } else {
      storePopup.collection();
    }
  }

  return (
    <div className={`menu-left-container ${match && `selected`} `} >
      {isConnected ? (
        <Link id={`link-ref-rp`} onClick={setHistory} style={{textDecoration: `none`}} to={isConnected ? '/collection' : '/'}>
          <div id={`ref-rp`} className={`flexRow align top-menu-container ${match && `selected`}`}>
            <IconCollection />
            <span className={`type-regular fz14`}>Collection</span>
          </div>
        </Link>
      ) : (
        <div onClick={setHistory} id={`ref-rp`} style={{cursor: 'pointer'}} className={`flexRow align top-menu-container ${match && `selected`}`}>
          <IconCollection />
          <span className={`type-regular fz14`}>Collection</span>
        </div>
      )}
    </div>     
  )
}

export default CollectionMenu;
